module.exports = __webpack_public_path__ + "static/media/icon.dc069aec.svg";